<div
  [ngClass]="{
    input: !(formControl.invalid && (formControl.touched || formControl.dirty)),
    'input-error': formControl.invalid && (formControl.touched || formControl.dirty)
  }"
>
  <label class="input-label-item" for="{{ for }}">{{ label }}</label>
  <input
    class="input-head-item"
    placeholder="{{ label }}"
    [formControl]="formControl"
  />
  @if (formControl.invalid && (formControl.touched || formControl.dirty)) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error-message">Este campo es requerido</div>
      }
      @if (formControl.errors?.['minlength']) {
        <div class="input-error-message">No cumple la longitud minima</div>
      }
      @if (formControl.errors?.['maxlength']) {
        <div class="input-error-message">No cumple la longitud maxima</div>
      }
      @if (formControl.errors?.['email']) {
        <div class="input-error-message">Correo Invalido</div>
      }
      @if (formControl.errors?.['phoneInvalid']) {
        <div class="input-error-message">
          {{ formControl.errors?.['phoneInvalid']?.message || 'Número de teléfono inválido' }}
        </div>
      }
      @if (formControl.errors?.['numericOnly']) {
        <div class="input-error-message">
          {{ formControl.errors?.['numericOnly']?.message || 'Solo se permiten números' }}
        </div>
      }
      @if (formControl.errors?.['maxDate']) {
        <div class="input-error-message">
          {{ formControl.errors?.['maxDate']?.message || 'Fecha no válida' }}
        </div>
      }
      @if (formControl.errors?.['invalidPattern']) {
        <div class="input-error-message">
          El campo contiene caracteres no permitidos
        </div>
      }
    </div>
  }
  @if (helpLabel && !(formControl.errors?.['email'] && (formControl.touched || formControl.dirty))) {
    <div class="input-help-label">
      {{ helpLabel }}
    </div>
  }
</div>
